/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum LearningCompetenceTypeEnum {
    ProfessionalCompetence = 'ProfessionalCompetence',
    TransversalCompetence = 'TransversalCompetence',
    KeyCompetence = 'KeyCompetence',
    GreenCompetence = 'GreenCompetence',
    DigitalCompetence = 'DigitalCompetence',
    Knowledge = 'Knowledge',
    Skill = 'Skill',
    ResponsibilityAutonomy = 'ResponsibilityAutonomy'
}

export function LearningCompetenceTypeEnumFromJSON(json: any): LearningCompetenceTypeEnum {
    return LearningCompetenceTypeEnumFromJSONTyped(json, false);
}

export function LearningCompetenceTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): LearningCompetenceTypeEnum {
    return json as LearningCompetenceTypeEnum;
}

export function LearningCompetenceTypeEnumToJSON(value?: LearningCompetenceTypeEnum | null): any {
    return value as any;
}

